<!--
 * @Author: M.D.
 * @Date: 2019-12-31 15:44:23
 * @LastEditors  : M.D.
 * @Description: 商品分类过滤组件（企业服务、企业培训、商品分类）
 * @Remarks:
 -->
<template>
  <div class="prd-cate-fliter-w">
    <ul class="outer-list-ul">
      <!-- 种类分类 -->
      <li class="outer-list-li" v-show="topFilterId === '1'">
        <div class="cate-name">种类：</div>
        <ul class="cate-inner-list">
          <li
            class="cate-i-item"
            :class="{ active: topCateActIdx === t.id }"
            @click="topCateChg(t)"
            v-for="t in topCateArr"
            :key="t.id"
          >
            {{ t.name }}
          </li>
        </ul>
      </li>

      <!-- 类型分类 -->
      <li class="outer-list-li" v-show="topCateActIdx !== '5'">
        <div class="cate-name">类型：</div>
        <ul class="cate-inner-list">
          <li
            class="cate-i-item"
            :class="{ active: sub1CateActIdx === t.id }"
            @click="sub1CateChg(t)"
            v-for="t in sub1CateArr"
            :key="t.id"
          >
            {{ t.name }}
          </li>
        </ul>
      </li>
      <!-- -->
      <li class="outer-list-li" v-if="$route.name === 'qypx'">
        <div class="cate-name">线上/线下：</div>
        <ul class="cate-inner-list">
          <li
            class="cate-i-item"
            :class="{ active: isOnTrain === t.id }"
            @click="isOnTrainChg(t)"
            v-for="t in isOnlineOption"
            :key="t.id"
          >
            {{ t.name }}
          </li>
        </ul>
      </li>

      <!-- 地区分类 -->
      <li class="outer-list-li" v-if="showArea">
        <div class="cate-name">地区：</div>
        <ul class="cate-inner-list">
          <li
            class="cate-i-item"
            :class="{ active: areaCateActIdx === t.id }"
            @click="areaCateChg(t)"
            v-for="t in areaCateArr"
            :key="t.id"
          >
            {{ t.name }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import API from '@/api/api'
import { mapGetters, mapActions } from 'vuex'
import { getSubArea } from '@/util/area'

export default {
  props: {},
  data() {
    return {
      // 总分类类型
      topCateArr: [
        { id: '1', name: '全部' },
        { id: '2', name: '企业服务' },
        { id: '3', name: '企业培训' },
        { id: '4', name: '增值服务' },
        { id: '5', name: '会员商品' },
      ],
      topCateActIdx: '0',

      // 类型分类
      sub1CateArr: [],
      sub1CateActIdx: '-1',

      // 地区分类
      areaCateArr: [],
      areaCateActIdx: '-1',

      // areaInfo
      areaInfo: {},

      // 全部、线上、线下
      isOnlineOption: [
        {
          id: '',
          name: '全部',
        },
        {
          id: '1',
          name: '线上',
        },
        {
          id: '2',
          name: '线下',
        },
      ],
      isOnTrain: '',
    }
  },
  computed: {
    ...mapGetters(['curLoc', 'userInfo']),
    topFilterId() {
      return !this._.includes(['qyfw', 'qypx'], this.$route.name)
        ? '1'
        : this.$route.name === 'qyfw'
        ? '2'
        : '3'
    },
    showArea() {
      if (this.userInfo.username) {
        if (this.userInfo.areaCode) {
          this.setCurLoc(this.userInfo.areaCode)
        }
        return this.userInfo.areaCode === ''
      } else {
        return this.curLoc.length !== 0
      }
    },
  },
  created() {
    // init 种类
    this.initTopFilter()
    this.initAreaCate()
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {
    curLoc() {
      this.initAreaCate()
    },
    userInfo() {
      this.initAreaCate()
    },
  },
  methods: {
    ...mapActions(['setCurLoc']),
    initTopFilter() {
      this.topCateChg(
        { id: this.topFilterId },
        !this._.includes(['qyfw', 'qypx'], this.$route.name),
      )
    },
    // 总分类切换
    async topCateChg(t, i = true) {
      this.topCateActIdx = t.id
      if (t.id === '5') {
        this.emitInfo()
        return
      }
      const re = await API.get1SubCateArr(t.id)
      this.sub1CateArr = re.data.result
      // “加全部
      this.sub1CateArr.unshift({
        id: '',
        name: '全部',
        status: 0,
        parentId: '-9999',
      })
      this.sub1CateActIdx = this.sub1CateArr[0].id
      this.emitInfo()
    },

    // 类型切换
    sub1CateChg(t) {
      console.log('类型', t)
      this.sub1CateActIdx = t.id
      this.emitInfo()
    },

    // 地区切换
    areaCateChg(t) {
      this.areaCateActIdx = t.id
      this.emitInfo()
    },

    // 线上线下切换
    isOnTrainChg(t) {
      this.isOnTrain = t.id
      this.emitInfo()
    },

    // 初始化地区分类
    initAreaCate() {
      if (this.userInfo.username) {
        this.areaCateArr = getSubArea([
          this.userInfo.provinceCode,
          this.userInfo.cityCode,
        ]).children

      } else {
        this.areaCateArr = getSubArea(this.curLoc).children
      }
      if (this.areaCateArr) {
        this.areaCateArr.unshift({ id: '', name: '全部', children: [] })
        this.areaCateActIdx = this.areaCateArr[0].id
      }
    },

    emitInfo() {
      console.log('======index')
      // console.log(this.topCateActIdx)
      const {
        topCateActIdx,
        sub1CateActIdx,
        areaCateActIdx,
        curLoc,
        isOnTrain,
      } = this
      this.$emit('filterInfo', {
        topCateActIdx,
        sub1CateActIdx,
        areaCateActIdx,
        curLoc,
        isOnTrain,
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.prd-cate-fliter-w {
  box-sizing: border-box;

  .outer-list-li {
    display: flex;
    margin-bottom: 10px;

    .cate-name {
      flex: 0 0 130px;
      padding: 0 10px;
      height: 44px;
      line-height: 44px;
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(255, 122, 0, 0.15);
      border-radius: 8px;
      font-family: AdobeHeitiStd-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #666666;
      box-sizing: border-box;
      margin-right: 20px;
    }

    .cate-inner-list {
      max-width: 90%;

      .cate-i-item {
        display: inline-block;
        padding: 0 20px;
        border-radius: 3px;
        height: 44px;
        line-height: 44px;
        font-family: AdobeHeitiStd-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;

        &:hover {
          cursor: pointer;
          color: theme-color;
        }

        &.active {
          background-color: theme-color;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
